@let data = (model.state.items$ | async) ?? [];

<div class="table-wrapper" [ngClass]="{ 'flex-grow-1': data.length === 0 }">
  <app-data-grid
    [dateFormatType]="'grid-date-time-sec'"
    [noDataTitle]="'search.no-data-title' | translate"
    [columns]="(model.state.columns$ | async) ?? []"
    [data]="data"
    [sortOrder]="(model.state.gridSortOrder$ | async) || undefined"
    [isLoading]="(model.state.isPending$ | async) ?? false"
    [isLoadingMore]="(model.state.isLoadingNextPage$ | async) ?? false"
    [paginationEnabled]="(model.state.canLoadNextPage$ | async) ?? false"
    [templates]="{ action: actionTmpl, category: categoryTmpl, userName: userNameTmpl }"
    (sortUpdated)="model.setOrder($event)"
    (loadMoreClicked)="model.loadNextPage()"
  ></app-data-grid>
</div>

<ng-template #userNameTmpl let-row="row">
  <div class="username text-14 fw-400" [class]="{ username__system: !row.userId && !row.userName }">
    {{ row.userName }}
  </div>
</ng-template>

<ng-template #actionTmpl let-row="row">
  <div
    class="action text-14 fw-400"
    [innerHTML]="row.actionKey | translate: row.actionData ?? {}"
  ></div>
</ng-template>

<ng-template #categoryTmpl let-row="row">
  <div class="category text-14 fw-400">{{ row.categoryName }}</div>
</ng-template>
